module.exports = __webpack_public_path__ + "media/images/landing_page/marketing_dashboard-6f320da6aacfe4d0b6e6d146feee5908.png";